import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Location } from '../../../types/location/location';
import {
  StyledContainerItems,
  StyledTitleSideBar,
  StyledContainerFooterSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarEditablePropertyItem } from '../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { usePutLocationMutation } from '../../../services/device/deviceService';

export const ChangeLocationNameBar = ({
  location,
  setOpenRightSideBar,
  reloadTable
}: {
  location: {
    locationId: number;
    ownerId: number;
    name: string;
    geoInfo: {
      latitude: number;
      longitude: number;
      address: string;
    };
  };
  setOpenRightSideBar: (open: boolean) => void;
  reloadTable: () => void;
}) => {
  const [updateLocationName, { isSuccess }] = usePutLocationMutation();
  usePutLocationMutation();
  const [locationName, setLocationName] = useState(location?.name || '');

  const handleSubmit = () => {
    updateLocationName({
      id: location.locationId,
      OwnerId: location.ownerId,
      Name: locationName,
      GeoInfo: {
        Latitude: location.geoInfo.latitude,
        Longitude: location.geoInfo.longitude,
        Address: location.geoInfo.address
      }
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Successfully updated location name');
      reloadTable();
    }
  }, [isSuccess]);
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.locations.changeLocationName}
        </StyledTitleSideBar>
        <SideBarEditablePropertyItem
          item={{
            label: 'Name',
            type: 'input',
            currentValue: locationName,
            nameAndId: 'name',
            onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
              setLocationName(e.target.value)
          }}
        />
      </StyledContainerItems>

      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={!locationName}
          onClick={() => handleSubmit()}
        >
          {Strings.common.send}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
